import dayjs from "dayjs";
import { sortBy } from "lodash";
import { TK_CATEGORY_UI_SORT_ORDER } from "lookup";

export const customComparator = (a, b) => {
  if (a.endDate === null && b.endDate === null)
    return dayjs(b.startDate).diff(a.startDate);
  else if (a.endDate === null) return -1;
  else if (b.endDate === null) return 1;
  else {
    const endDateComparison = dayjs(b.endDate).diff(a.endDate);
    return endDateComparison === 0
      ? dayjs(b.startDate).diff(a.startDate)
      : endDateComparison;
  }
};

export const convertMilesToMeters = (distanceInMiles = 0) => {
  return Math.round(distanceInMiles * 1.60934 * 1000);
};

export const getGroupedSkillsByCategory = (TKSkills) => {
  const skillsByCategory = {};

  // group skills by category
  for (const TKSkill of TKSkills || []) {
    const { category } = TKSkill;

    if (!skillsByCategory[category]) {
      skillsByCategory[category] = [];
    }

    skillsByCategory[category].push(TKSkill);
  }

  return sortBy(Object.keys(skillsByCategory), (key) => {
    const index = TK_CATEGORY_UI_SORT_ORDER.indexOf(key);
    return index === -1 ? TK_CATEGORY_UI_SORT_ORDER.length + key : index;
  }).reduce((acc, key) => {
    acc[key] = skillsByCategory[key];
    return acc;
  }, {});
};

export const buildTKSkillHierarchy = (TKSkills) => {
  const flatHierarchy = [];

  TKSkills.forEach((skill) => {
    const category = skill.category;

    flatHierarchy.push(category);

    const lvl1 = `${category} > ${skill.name}`;
    flatHierarchy.push(lvl1);

    flatHierarchy.push(`${lvl1} > low`);

    flatHierarchy.push(`${lvl1} > medium`);

    flatHierarchy.push(`${lvl1} > high`);
  });

  return [...new Set(flatHierarchy)];
};

const _toBullhornRate = (value) => {
  if (!value && value !== 0) {
    return undefined;
  }

  const rate = Number(value);

  return Number.isFinite(rate) ? { value: rate, currency: "USD" } : undefined;
};

export const isBullhornPublishedSalary = (rate) => rate?.value > 1000;

export const getBullhornPublishedRates = (metadata) => {
  if (!metadata) {
    return {};
  }

  try {
    const parsedMetadata =
      typeof metadata === "string" ? JSON.parse(metadata) : metadata;
    const bullhorn =
      typeof parsedMetadata?.BULLHORN === "string"
        ? JSON.parse(parsedMetadata.BULLHORN || "{}")
        : parsedMetadata?.BULLHORN || {};

    return {
      low: _toBullhornRate(bullhorn["Published Rate Low"]),
      high: _toBullhornRate(bullhorn["Published Rate High"]),
    };
  } catch (e) {
    console.error(`Failed to parse bullhorn metadata: \n ${e}`);
    return {};
  }
};
